(ns teamoesterreich.admin-mode.warnings.warnung-form
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.save :refer [save]]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.view-state :as v-state]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.warning :as d-warning]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [reagent-material-ui.icons.send :refer [send]]
            [teamoesterreich.admin-mode.warnings.warning-region :as warning-region]
            [teamoesterreich.util.log :as log]
            ))

(def warn-level {1 "Stufe 1"
                 2 "Stufe 2"
                 3 "Stufe 3"
                 4 "Stufe 3"
                 5 "Stufe 4"})



(defn detail-form [!form !form-hash !edit-mode changed? !orig !selected change-fn !activate-warning editable?]
  [:form

   [mui/grid
    {:container  true
     :direction  "row"
     :justify    "flex-start"
     :alignItems "flex-start"
     :spacing    3
     }

    ;; Quelle / Typ / Level


    [mui/grid
     {:container false :item true
      :md        3
      :xs        6
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style           {:backgroundColor (if (changed? :warningCap-source) "#ffd6d2" "#ffffff")}
                      :InputLabelProps {:disableAnimation true :shrink true}
                      :fullWidth       true
                      :disabled        true
                      :defaultValue    (str (:warningCap-source @!form))
                      :label           "Quelle"}]]



    [mui/grid
     {:container false :item true
      :md        3
      :xs        6
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style           {:backgroundColor (if (changed? :warningCap-warnType) "#ffd6d2" "#ffffff")}
                      :InputLabelProps {:disableAnimation true :shrink true}
                      :fullWidth       true
                      :disabled        true
                      :defaultValue    (str (get-in @!form [:warningCap-warnType :warningType-name]))
                      :label           "Art"}]]

    [mui/grid
     {:container false :item true
      :md        3
      :xs        6
      :style     {:padding "5px" :text-align "left"}
      }
     [mui/form-label {:style {:font-size "0.8rem"}} "Level"
      [mui/select
       {:fullWidth true
        :style     {:background-color (if (changed? :warningCap-level) "#ffd6d2" "#ffffff")}
        :value     (:warningCap-level @!form)
        :disabled  (not @!edit-mode)
        :onChange  (fn [e]
                     (js/console.log "Change type  -> " (h/event-value e))
                     (swap! !form assoc-in [:warningCap-level] (h/event-value e)))
        }
       (for [[k name] warn-level]
         ^{:key (str "warningCap-level-" k)} [mui/menu-item {:style {} :value k} name])
       ]]
     [mui/grid {:container false :item true :xs 12}
      ]]

    ;; Start

    [mui/grid
     {:container false :item true
      :md        5
      :xs        6
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style           {:backgroundColor (if (changed? :warningCap-start) "#ffd6d2" "#ffffff")}
                      :InputLabelProps {:disableAnimation true :shrink true}
                      :fullWidth       true
                      :type            "datetime-local"
                      :disabled        (not @!edit-mode)

                      :defaultValue    (h-date/unix-date-2-date-form (:warningCap-start @!form))
                      :onChange        (fn [e]
                                         ;(js/console.log "ööööööööööö" (h-date/date-form-2-unix-date (h/event-value e)))
                                         (change-fn :warningCap-start (h-date/date-form-2-unix-date (h/event-value e)))
                                         )
                      :label           "Start"}]
     ]
    ;; End
    [mui/grid
     {:container false :item true
      :md        4
      :xs        6
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style           {:backgroundColor (if (changed? :warningCap-end) "#ffd6d2" "#ffffff")}
                      :InputLabelProps {:disableAnimation true :shrink true}
                      :fullWidth       true
                      :type            "datetime-local"
                      :disabled        (not @!edit-mode)
                      :defaultValue    (h-date/unix-date-2-date-form (:warningCap-end @!form))
                      :onChange        (fn [e]
                                         ;(js/console.log "ööööööööööö" (h-date/date-form-2-unix-date (h/event-value e)))
                                         (change-fn :warningCap-end (h-date/date-form-2-unix-date (h/event-value e)))
                                         )
                      :label           "Ende"}]
     ]
    ;; Title

    [mui/grid
     {:container false :item true
      :md        6
      :xs        10
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style           {:backgroundColor (if (changed? :warningCap-headline) "#ffd6d2" "#ffffff")}
                      :InputLabelProps {:disableAnimation true :shrink true}
                      :fullWidth       true
                      :disabled        (not @!edit-mode)
                      :defaultValue    (str (:warningCap-headline @!form))
                      :onChange        (fn [e] (change-fn :warningCap-headline (h/event-value e)))
                      :label           "Warnung Überschrift"}]
     ]


    [mui/grid
     {:container false :item true
      :md        6
      :xs        2
      :style     {:padding "5px"}
      }
     ]

    ;; Description


    [mui/grid
     {:container false :item true
      :md        6
      :xs        10
      :style     {:padding "5px"}
      }
     [mui/text-field {
                      :style        {:backgroundColor (if (changed? :warningCap-description) "#ffd6d2" "#ffffff")}
                      :fullWidth    true
                      :disabled     (not @!edit-mode)
                      :multiline    true
                      :rows         5
                      :defaultValue (str (:warningCap-description @!form))
                      :onChange     (fn [e] (change-fn :warningCap-description (h/event-value e)))
                      :label        "Warnung Text"}]
     ]


    [mui/grid
     {:container false :item true
      :md        6
      :xs        2
      :style     {:padding "5px"}
      }
     ]




    [mui/grid
     {:container false :item true
      :md        12 :xs 12
      :style     {:marginTop "5px"}
      }
     (when @!edit-mode
       [mui/button {:startIcon (r/as-element [cancel]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                    :onClick   (fn []
                                 (reset! !form @!orig)
                                 (reset! !form-hash (rand-int 12))
                                 (reset! !edit-mode false))
                    }
        "Abbrechen"])

     (when @!edit-mode
       [mui/button {:startIcon (r/as-element [save]) :variant "outlined" :color "primary" :style {:margin "5px 40px 5px 0"}
                    :disabled  (not (or
                                      (changed? :warningCap-warnType)
                                      (changed? :warningCap-level)
                                      (changed? :warningCap-headline)
                                      (changed? :warningCap-end)
                                      (changed? :warningCap-start)
                                      (changed? :warningCap-description)
                                      ))
                    :onClick   (fn []
                                 (d-warning/>warning-edit (:warningCap-uuid @!form)
                                                          (select-keys @!form [:warningCap-level :warningCap-headline :warningCap-description :warningCap-start :warningCap-end])
                                                          (fn [r]
                                                            (js/console.log "######################" (clj->js r))
                                                            )))
                    }
        "Speichern"])

     (when-not @!edit-mode
       [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                    :onClick   (fn []
                                 (reset! !selected nil)
                                 (a/set-page :warning-list))
                    }
        "Zurück"])

     (when (and editable? (not @!edit-mode) (d-rights/is-superuser?))
       [mui/button {:startIcon (r/as-element [edit]) :variant "outlined" :color "secondary" :style {:margin "5px 40px 5px 0"}
                    :onClick   #(reset! !edit-mode true)
                    }
        "Bearbeiten"])

     (when (and (not editable?) (not @!edit-mode) (d-rights/is-superuser?))
       [mui/button {
                    :variant   "outlined"
                    :style     {:color "orange" :margin "5px 40px 5px 40px"}
                    :startIcon (r/as-element [edit])
                    :onClick   #(reset! !edit-mode true)
                    } "Bearbeiten (superuser)"])

     (when (not @!edit-mode)
       [mui/form-control-label
        {:style     {:paddingLeft "16px" :paddingRight "16px" :backgroundColor (if (changed? :warningCap-active) "#ffd6d2" "#ffffff")}
         :label     "Warnung aktivieren"
         :fullWidth true
         :control   (r/as-element [mui/switch {:variant  "contained"
                                               :disabled (not (or editable? (d-rights/is-superuser?)))
                                               :checked  (or (:warningCap-active @!form) false)
                                               :onClick  (fn []
                                                           (if (not (:warningCap-active @!form))
                                                             (reset! !activate-warning true)
                                                             (d-warning/>warning-edit (:warningCap-uuid @!form) {:warningCap-active false} (fn []))))
                                               }])}
        ])

     ]
    ]
   ]
  )

(defn get-form [!selected]
  (let [!st (r/atom {:form nil :loaded false :form-hash (rand-int 12)})
        !tab (r/cursor !st [:tab])
        !form-hash (r/cursor !st [:form-hash])
        !form (r/cursor !st [:form])
        !orig (r/cursor !st [:orig])
        !edit-mode (r/cursor !st [:edit-mode])
        !loaded (r/cursor !st [:loaded])
        !activate-warning (r/cursor !st [:send-push])

        editable? (= "ork" (get-in @!form [:warningCap-warnType :warningType-abbr]))
        change-fn (fn [e v]
                    (swap! !form assoc e v))
        changed? (fn [k]
                   (not= (get @!orig k) (get @!form k)))]
    (fn []
      [mui/paper
       (if-not @!loaded
         (do
           (d-warning/<get-warning @!selected
                                   (fn [data]
                                     (swap! !st assoc
                                            :orig data
                                            :form data
                                            :loaded true
                                            )))
           [:div {:style {:marginTop "10px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  Dienststelle loading..."])

         [mui/card
          {:style {:margin "10px"}}

          [are-you-sure-modal/are-you-sure-modal !activate-warning (str "Willst du diese Warnung wirklich veröffentlichen und alle Betroffenen alarmieren?") "Aktivieren"
           (fn [] (d-warning/>warning-edit (:warningCap-uuid @!form) {:warningCap-active true} (fn [])))]

          (log/debug "rerender form " (clj->js @!form))
          [mui/card-header {:title "Warnung"}]
          [mui/card-content
           [mui/tabs {:value          (or @!tab 0)
                      :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                      :indicatorColor "primary"
                      :textColor      "primary"
                      :variant        "scrollable"
                      }
            [mui/tab {:value 0 :label "Details"}]

            [mui/tab {:value 1 :label "Region"}]
            ;[mui/tab {:value 99 :label "debug"}]
            ]
           ;;show-absent? show-standby? show-participated?
           (case (or @!tab 0)
             0 [detail-form !form !form-hash !edit-mode changed? !orig !selected change-fn !activate-warning editable?]

             1 [mui/card-content {}
                [warning-region/region-selector !form editable?]]

             99 [mui/card-content {}
                 [:div {:style {:text-align "left"}}
                  "warning"
                  [:pre
                   (h/pretty-map @!orig)
                   ]
                  ]]

             )

           ]])])))

(defn get-it []
  (fn []
    (let [!selected (r/cursor v-state/app-state [:warning-list :selected])]
      [:div
       [get-form !selected]
       ])))






